import Vue from 'vue';
import Vuex from 'vuex';
import moment from 'moment-timezone';

import acarsData from '../assets/acars-data.json';
import auth from './auth.module';
import userStation from './userStation.module';

Vue.use(Vuex);

interface State {
  acarsData: any
  activeFlights: any[]
  airframes: any[]
  messagesLive: any[]
  apiServerBaseUrl: String
  clients: any
  isConnected: Boolean
  isProduction: Boolean
  isLiveMessagesPaused: Boolean
  messagesCountSinceIntervalStart: Number
  messagesHistorical: any[]
  messagesLivePerSecond: Number
  messagesLiveCountLast: Number
  lastMessageFromAirframes: any[]
  lastMessageFromStations: any[]
  stations: any[]
  stats: any
}

export default new Vuex.Store<State>({
  modules: {
    auth,
    userStation,
  },
  state: {
    acarsData,
    activeFlights: [],
    airframes: [],
    apiServerBaseUrl: process.env.NODE_ENV === 'production' ? 'https://api.airframes.io' : 'http://localhost:3001',
    clients: {},
    isConnected: false,
    isProduction: process.env.NODE_ENV === 'production',
    isLiveMessagesPaused: false,
    messagesCountSinceIntervalStart: 0,
    messagesHistorical: [],
    messagesLive: [] as any[],
    messagesLivePerSecond: 0,
    messagesLiveCountLast: 0,
    lastMessageFromAirframes: [],
    lastMessageFromStations: [],
    stations: [],
    stats: {},
  },
  mutations: {
    socket_clients(state, clients) {
      console.log('Store: socket_clients');
      Vue.set(state, 'clients', clients);
    },
    socket_connect(state, status) {
      console.log('Store: socket_connect');
      state.isConnected = true;
    },
    accountForMessageRate(state: any, newMessages: Array<any>) {
      Vue.set(state, 'messagesCountSinceIntervalStart', state.messagesCountSinceIntervalStart + newMessages.length);
    },
    calculateMessagesLivePerSecond(state: any) {
      console.log('Store: calculateMessagesLivePerSecond');
      console.log(`Store: DEBUG: isLiveMessagesPaused: ${state.isLiveMessagesPaused}, messagesCountSinceIntervalStart: ${state.messagesCountSinceIntervalStart}`);
      Vue.set(state, 'messagesLivePerSecondLast', state.messagesLivePerSecond);
      if (!state.isLiveMessagesPaused) {
        const { messagesLiveCountLast } = state;
        const mps = state.messagesCountSinceIntervalStart / 5;
        Vue.set(state, 'messagesLivePerSecond', mps);
      } else {
        Vue.set(state, 'messagesLivePerSecond', 0);
      }
      Vue.set(state, 'messagesCountSinceIntervalStart', 0);
    },
    initializeStore(state) {
      console.log('Store: initializeStore');
      const existingAirframes = localStorage.getItem('airframes');
      if (existingAirframes) {
        Vue.set(state, 'airframes', JSON.parse(existingAirframes));
      }

      const existingStations = localStorage.getItem('stations');
      if (existingStations) {
        Vue.set(state, 'stations', JSON.parse(existingStations));
      }
    },
    pauseLiveMessages(state: any) {
      console.log('Store: pauseLiveMessages');
      Vue.set(state, 'isLiveMessagesPaused', true);
    },
    playLiveMessages(state: any) {
      console.log('Store: playLiveMessages');
      Vue.set(state, 'isLiveMessagesPaused', false);
    },
    prependNewLiveMessages(state: any, newMessages: Array<any>) {
      // console.log('Store: prependNewLiveMessages');
      Vue.set(state, 'messagesLive', newMessages.concat(state.messagesLive).slice(0, 100));
    },
    setAirframes(state: any, airframes: Array<any>) {
      console.log('Store: setAirframes');
      Vue.set(state, 'airframes', airframes);
    },
    setActiveFlights(state: any, flights: Array<any>) {
      console.log('Store: setActiveFlights');
      Vue.set(state, 'activeFlights', flights);
    },
    setLastHeardFromAirframe(state: any, tail: any) {
      // console.log('Store: setLastHeardFromAirframe');
      if (!state.isLiveMessagesPaused) {
        let { lastMessageFromAirframes } = state;

        const filter = function t(last: any) {
          const lastDate = moment(last.when);
          const now = moment();
          const diff = now.diff(lastDate, 'minutes');
          return last.tail !== tail && diff < 5;
        };

        lastMessageFromAirframes = lastMessageFromAirframes.filter(filter);

        const last = { tail, when: Date.now() };
        lastMessageFromAirframes.push(last);
        lastMessageFromAirframes = lastMessageFromAirframes.sort((a: any, b: any) => (b.when - a.when)); // eslint-disable-line max-len

        Vue.set(state, 'lastMessageFromAirframes', lastMessageFromAirframes);
      }
    },
    setStations(state: any, stations: Array<any>) {
      console.log('Store: setStations');
      Vue.set(state, 'stations', stations);
    },
    setStats(state: any, stats: any) {
      console.log('Store: setStats');
      Vue.set(state, 'stats', stats);
    },
  },
  actions: {
    socket_activeFlights({ commit, dispatch }, flights) {
      commit('setActiveFlights', flights);
    },
    socket_newMessages({ commit, dispatch }, messages) {
      // console.log('Store: Socket: newMessages');
      commit('accountForMessageRate', messages);
      commit('prependNewLiveMessages', messages);
    },
    socket_airframes({ commit, dispatch }, airframes) {
      commit('setAirframes', airframes);
    },
    socket_clients({ commit, dispatch }, clients) {
      commit('socket_clients', clients);
    },
    socket_stations({ commit, dispatch }, stations) {
      // console.log('Store: Socket: stations');
      commit('setStations', stations.sort((a: any, b: any) => (b.messagesCount - a.messagesCount)));
    },
  },
});
